// extracted by mini-css-extract-plugin
export default {"mail":"ConsentLoading_mail__EaQOW"};